export default __webpack_public_path__ + "static/media/06.06b004f3.png";